import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  HOURS,
  LEAVE_OPTIONS,
  LEAVE_TYPES,
  MINUTES,
  PROJECT_CATEGORY,
} from "../../../app/utils/constants/option";
import "./SelectInput.scss";

const SelectInput = (props) => {
  const {
    label,
    selected,
    placeholder,
    type,
    manualOptions,
    className,
    classNameInput,
    onChange,
    isDisabled,
    isClearable = true,
  } = props;
  const [options, setOptions] = useState([]);
  const [selecteOption, setSelecteOption] = useState();

  useEffect(() => {
    if (Array.isArray(manualOptions) && manualOptions.length) {
      if (selected && typeof selected === "object" && selected.value) {
        setSelecteOption(selected);
      } else {
        setSelecteOption(manualOptions.find((ele) => ele.value === selected));
      }
      return;
    }
    if (selected && typeof selected === "object" && selected.value) {
      // If selected is already an object with value/label, use it directly
      setSelecteOption(selected);
    } else {
      // Otherwise, find the option in the predefined lists
      switch (type) {
        case "leave":
          setSelecteOption(LEAVE_OPTIONS.find((ele) => ele.value === selected));
          break;
        case "leaveType":
          setSelecteOption(LEAVE_TYPES.find((ele) => ele.value === selected));
          break;
        case "projectCategory":
          setSelecteOption(
            PROJECT_CATEGORY.find((ele) => ele.value === selected)
          );
          break;
        case "hours":
          setSelecteOption(
            PROJECT_CATEGORY.find((ele) => ele.value === selected)
          );
          break;
        case "minutes":
          setSelecteOption(MINUTES.find((ele) => ele.value === selected));
          break;
      }
    }
  }, [selected, manualOptions]);
  useEffect(() => {
    if (selected === null || selected === undefined || selected?.length === 0) {
      setSelecteOption("");
    }
  }, [selected]);

  useEffect(() => {
    if (Array.isArray(manualOptions) && manualOptions.length) {
      setOptions(manualOptions);
      return;
    }
    switch (type) {
      case "leave":
        setOptions(LEAVE_OPTIONS);
        break;
      case "leaveType":
        setOptions(LEAVE_TYPES);
        break;
      case "projectCategory":
        setOptions(PROJECT_CATEGORY);
        break;
      case "hours":
        setOptions(HOURS);
        break;
      case "minutes":
        setOptions(MINUTES);
        break;
    }
  }, [manualOptions, type]);

  return (
    <div className={`${className} select-input`}>
      <div className="form-label">{label}</div>
      <Select
        isDisabled={isDisabled}
        value={selecteOption}
        placeholder={placeholder}
        options={options}
        onChange={onChange}
        isClearable={isClearable && !isDisabled}
        className={`react-select-container ${classNameInput || ""}`.trim()}
        classNamePrefix="react-select"
        isMulti={false}
        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
        menuPosition="fixed"
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            // borderRadius: state.menuIsOpen ? '18px 18px 0 0' : '33px',
            borderRadius: "0.375rem",
            boxShadow: "none",
            background: state.isFocused
              ? "linear-gradient(white, white) padding-box,linear-gradient(95.39deg, #B2D236 9.4%, #2BB24B 51.68%, #01A8AC 96.92%) border-box"
              : isDisabled || props.disabled
              ? "#e5e7eb"
              : "#ffffff",
            border: state.isFocused
              ? "1.5px solid #0c4a6e"
              : props.emptyInput
              ? "1px solid red !important"
              : "1px solid #d8dfed",
            // borderBottom: state.menuIsOpen ? 'none' : '',
            "&:hover": {
              background:
                isDisabled || props.disabled
                  ? "#d1d5db"
                  : "linear-gradient(white, white) padding-box,linear-gradient(95.39deg, #B2D236 9.4%, #2BB24B 51.68%, #01A8AC 96.92%) border-box",
              border: "2px solid #0c4a6e",
            },
            minHeight: "44px",
            cursor: isDisabled || props.disabled ? "no-drop" : "pointer",
          }),
          menuPortal: (base) => ({ ...base, zIndex: 4000 }),
          menu: (base) => ({ ...base, backgroundColor: "#ffffff", zIndex: 4000 }),
          menuList: (base) => ({ ...base, backgroundColor: "#ffffff" }),
          option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected
              ? "#6366f1"
              : state.isFocused
                ? "#eef2ff"
                : "#ffffff",
            color: state.isSelected ? "#ffffff" : "#111827",
          }),
          singleValue: (base) => ({ ...base, color: "#111827" }),
          placeholder: (base) => ({ ...base, color: "#6b7280" }),
          // multiValue: (baseStyles, state) => ({
          //     ...baseStyles,
          //     backgroundColor: 'transparent',
          //     borderRadius: '12px',
          //     border: '1px solid #c0cece',
          //     marginTop: '2.5px',
          //     marginLeft: '5px',
          //     borderColor: '#01a8ac',
          //     cursor: props.disabled ? 'no-drop' : 'default',
          //     "&:hover": {
          //         background: props.disabled ? '#c0cece6e' : 'linear-gradient(white, white) padding-box,linear-gradient(95.39deg, #B2D236 9.4%, #2BB24B 51.68%, #01A8AC 96.92%) border-box',
          //         border: '1px solid transparent'
          //     },
          // })
        }}
      />
    </div>
  );
};

export default SelectInput;
